import { Component, ComponentInterface, h, Host, Prop, Element, State } from '@stencil/core';

@Component({
    tag: 'sew-ws-teaser',
    styleUrl: 'sew-ws-teaser.scss',
    shadow: false,
})
export class SewWsTeaser implements ComponentInterface {
    @Element() host: HTMLSewWsTeaserElement;

    @Prop({ reflect: true }) noGrid = false;
    @Prop({ reflect: true }) noMargin = false;
    @Prop({ reflect: true }) columns = '3';

    @Prop() headline: string;

    @State() hasDownloadSlot = false;

    componentWillLoad(): void {
        this.hasDownloadSlot = !!this.host.querySelector('[slot="download"]');
        this.host.style.setProperty('--columns', this.columns);
    }

    render() {
        return (
            <Host>
                <div class="main-content-container">
                    {this.headline && (
                        <div class="limit-content-width">
                            <div>
                                <h2 innerHTML={this.headline}></h2>
                                <div class="intro">
                                    <slot name="intro"></slot>
                                </div>
                            </div>
                        </div>
                    )}
                    <div class="teaser-item">
                        <slot name="teaser-item" />
                    </div>
                    {this.hasDownloadSlot && (
                        <div class="download">
                            <slot name="download" />
                        </div>
                    )}
                </div>
            </Host>
        );
    }
}
